import { styled } from '@classify/react-core-components/styles';
import DoneIcon from '@mui/icons-material/Done';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import Typography from '@classify/react-core-components/Typography';
import { translate } from '@openclassrooms/translations';
import LearningStatus from './LearningStatus';
import { CHAPTER_STATUSES, STATUS_PROMOTION } from '../../../_constants/learningStatuses';
interface Props {
  status: (typeof CHAPTER_STATUSES)[number];
  chapterIndex?: number;
  color?: string;
  ariaHidden?: boolean;
}
const InProgressIcon = styled(RotateRightIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 18,
  height: 18,
  color: palette.progress.event.completed
}));
const PassedIcon = styled(DoneIcon)(({
  theme: {
    palette
  }
}) => ({
  width: 14,
  height: 14,
  color: palette.progress.learningAsset.onPassed
}));
const getLearningStatusIcon = (chapterIndex: number | undefined, color: string | undefined, ariaHidden: boolean) => ({
  [STATUS_PROMOTION]: <LearningStatus sx={{
    borderColor: color
  }}>
      <Typography variant="caption" sx={{
      color
    }}>
        {chapterIndex}
      </Typography>
    </LearningStatus>,
  'not started': <LearningStatus sx={{
    borderColor: 'progress.completion.disabled.active'
  }}>
      <Typography variant="caption" sx={{
      color: 'progress.completion.disabled.active'
    }}>
        {chapterIndex}
      </Typography>
    </LearningStatus>,
  'in progress': <LearningStatus sx={{
    borderColor: 'progress.event.completed'
  }}>
      <InProgressIcon aria-label={translate('courses.accessibility_labels.chapter.in_progress')} aria-hidden={ariaHidden} />
    </LearningStatus>,
  passed: <LearningStatus sx={{
    borderColor: 'progress.learningAsset.background.passed',
    backgroundColor: 'progress.learningAsset.background.passed'
  }}>
      <PassedIcon aria-label={translate('courses.accessibility_labels.chapter.passed')} aria-hidden={ariaHidden} />
    </LearningStatus>
});
const ChapterLearningStatus = ({
  status,
  chapterIndex,
  color = '',
  ariaHidden = false
}: Props) => {
  return getLearningStatusIcon(chapterIndex, color, ariaHidden)[status];
};
export default ChapterLearningStatus;